// extracted by mini-css-extract-plugin
module.exports = {"button-color":"LeftSide_button-color__R8xQz","input-dimensions":"LeftSide_input-dimensions__CP9_4","btn-clear":"LeftSide_btn-clear__AiKUN"};